<div
  class="container-md pb-4 p-md-0"
  [ngClass]="[shopping_cart ? 'ts-finalize-order-' + shopping_cart.orderTypeId : '']"
  [tds-data-loader]="{
    key: 'order-fields',
    global: true
  }"
>
  <tds-notifications
    [notifications]="validation_error_notifications"
    [notification_type]="'validation_error_notifications'"
    [notification_icon]="'close'"
    [notification_color]="'danger'"
  />

  <div class="row g-3">
    <ts-selected-asset
      *ngIf="shopping_cart && asset_details.existing_asset"
      page_key="finalize"
      [shopping_cart]="shopping_cart"
      [validation_errors]="validation_errors"
      [order_type_id]="shopping_cart.orderTypeId"
      [asset_details]="asset_details"
      [additional_info]="additional_info"
      (form_valid)="isFormValid($event)"
      (trigger_update_fields)="triggerUpdateFields($event)"
    />

    <div *ngIf="is_valid_cart" class="col col-12">
      <ts-cart-items
        [shopping_cart]="shopping_cart"
        [shopping_items_price]="shopping_items_price"
        (bulk_form_valid)="isBulkFormValid($event)"
        (is_bulk_order)="isBulkOrder($event)"
        (update_cart)="updateShoppingCartData($event)"
      />
    </div>

    <div class="col col-12">
      <ts-custom-form [form]="form" [json_form_data]="json_form_data" />
    </div>
  </div>
</div>

<ts-price-summary
  [hide_price_content]="hide_price_content"
  [hide_one_time_cost]="hide_one_time_cost"
  [button_status]="disable_order_submit || content_loading"
  [shopping_cart]="shopping_cart"
  [shopping_items_price]="shopping_items_price"
  [refresh_summary]="refresh_summary.asObservable()"
  (updateCostSummary)="getShoppingCartData($event)"
  (onContinueSuccess)="onContinueSuccess($event)"
/>
